// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"ba0306d1","720":"e7350226","908":"ee95ac13","977":"240addac"}[chunkId] + ".chunk.js";
};